import React from 'react';
// import classnames from 'classnames';
import PropTypes from 'prop-types';

const CardInputField = ({
    field, value, label, error, type, onChange, disabled, divClassName, placeholder,
}) => (


        <div className={divClassName}>

            <label htmlFor="Email" className="active">{label}</label>
            <input
                onChange={onChange}
                value={value}
                type={type}
                name={field}
                id={label}
                placeholder={placeholder !== "" ? " " : label}
                className="validate city-input"
                disabled={disabled}
                onClick={onChange}
                onFocus={onChange}

            // autoComplete="-"
            />


            {/* <input id="Email" type="text" placeholder="placeholder" className="validate" /> */}

            {error && <span className="help-block invalid ">{error}</span>}
        </div>
    );

CardInputField.propTypes = {
    field: PropTypes.string,
    value: PropTypes.any,
    label: PropTypes.string,
    error: PropTypes.any,
    type: PropTypes.string,
    divClassName: PropTypes.string,
    id: PropTypes.string,
    onChange: PropTypes.func,
    disabled: PropTypes.any,
    checkUserExists: PropTypes.func,
    viewPassword: PropTypes.func,
    req: PropTypes.any,
    passwordStatus: PropTypes.any
};

CardInputField.defaultProps = {
    type: 'text',
    disabled: false,
    req: false,
    passwordStatus: false,
    divClassName: '',
    id: '',
};

export default CardInputField;
